<template>
  <div>
    <div class="options-title">
      <div class="options-title__left">
        <p class="color-title">оснастка</p>
        <p class="quantity-title">кол-во</p>
      </div>
    </div>

    <div class="options-list">
      <div class="color">
        <div class="options-list__item"
          v-for="( forInstallationItem, forInstallationIndex ) in forInstallationList" :key="forInstallationIndex">
          <span>{{ forInstallationItem.name }}</span>
          <div class="input-block">
            <span class="minus" @click="minus(forInstallationItem.installationID)"></span>
            <input type="number" min="0" @change="setQuantity(forInstallationItem.quantity, forInstallationItem.installationID)"  v-model="forInstallationItem.quantity" />
            <span class="plus"  @click="plus(forInstallationItem.installationID)"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["forInstallationList", "element"],
  data: () => ({}),
  methods: {
    setQuantity(value, installationID){
      for(var key in this.forInstallationList){
        let installationItem = this.forInstallationList[key];
        if( parseInt(installationItem.installationID) == installationID){
          installationItem.quantity = value;
          this.localStorageUpdate(this.element, installationItem)
        }
      }
    },
    plus(id){
      for(var key in this.forInstallationList){
        let forInstallationItem = this.forInstallationList[key];
        if( parseInt(forInstallationItem.installationID) == id){
          forInstallationItem.quantity++;
          this.localStorageUpdate(this.element, forInstallationItem)
        }
      }
    },
    minus(id){
      for(var key in this.forInstallationList){
        let forInstallationItem = this.forInstallationList[key];
        if( parseInt(forInstallationItem.installationID) == id){
          if(forInstallationItem.quantity > 0){
            forInstallationItem.quantity--;
            this.localStorageUpdate(this.element, forInstallationItem)
          }else{
            forInstallationItem.quantity = 0;
            this.localStorageUpdate(this.element, forInstallationItem)
          }
        }
      }
    },
    localStorageUpdate(productId, cartItem){
      productId = 'productId_' + productId;
      let miniCart = this.$localStorageGet('miniCart');
      
      if(Object.keys(miniCart).length == 0){
        miniCart[productId] = [];
        miniCart[productId].push(cartItem);
        this.$localStorageSet('miniCart', miniCart)
      }else{
        this.updateMiniCart(miniCart, productId, cartItem)
      }
    },
    updateMiniCart(miniCart, productId, cartItem){
      
      if(miniCart[productId]){ //Если в миникорзине есть такой товар
      let currentOption = miniCart[productId].find(x => x.installationID == cartItem.installationID); //Выбранный оснастку
        if(currentOption){
            currentOption.quantity = cartItem.quantity;
            if(cartItem.quantity == 0){  //Если количество 0, удалить опцию из миникорзины
                miniCart[productId] = miniCart[productId].filter((item) => item.installationID != cartItem.installationID);
            }

            if(Object.keys(miniCart[productId]).length == 0){ //Если опции совсем не выбраны, удалить товар полностью из миникорзины
                delete miniCart[productId];
            }
            else if(Object.keys(miniCart[productId]).length == 1 && miniCart[productId][0]['rating'] != undefined){
              delete miniCart[productId];
            }

            this.$localStorageSet('miniCart', miniCart); //Перезаписать миникорзину в localStorage
        }else{ //Если товар есть, а оснастки нет
            miniCart[productId].push(cartItem) //добавить новый выбранную оснастку
            this.$localStorageSet('miniCart', miniCart); //Перезаписать миникорзину в localStorage
        }
      }else{
        miniCart[productId] = []; 
        miniCart[productId].push(cartItem); //Добавить новый товар и выбранный цвет к нему
        this.$localStorageSet('miniCart', miniCart); //Перезаписать миникорзину в localStorage
      }
    }
  }
};
</script>